import styled from 'styled-components';

import { APP_LAYOUT_SCREEN_CLASSNAME } from './constants';

export const Grid = styled.div`
  display: grid;
  grid-template-areas: 'sidebar screen';
  grid-template-columns: 240px auto;
  height: 100vh;
`;

export const Screen = styled.div.attrs({
  className: APP_LAYOUT_SCREEN_CLASSNAME,
})`
  grid-area: screen;
  overflow-y: auto;
`;

export const ContentBox = styled.div`
  padding: ${({ theme }) => theme.spacings.abs48}px 120px;
  height: 100vh;
  overflow-y: auto;
  @media (max-width: 1279px) {
    padding-left: ${({ theme }) => theme.spacings.abs64}px;
    padding-right: ${({ theme }) => theme.spacings.abs64}px;
  }
  @media (min-width: 1920px) {
    padding-left: 240px;
    padding-right: 240px;
  }
`;

export const FixedWidthContainer = styled.div`
  width: 600px;
`;
